export default "__VITE_ASSET__DkmOLaLY__"